import React from 'react';
import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-us-ui';

// Styled Components
//
// 1) STYLED COMPONENTS
//
// ${EmotionBreakpoint('tablet')} {
// ${EmotionBreakpoint('mobile')} {
const HighlightContainer = styled.div`
	margin-top: 90px;
	${EmotionBreakpoint('mobile')} {
		padding: 26px 16px;
		margin-top: 65px;
	}
	${EmotionBreakpoint('tablet')} {
		padding: 26px 16px;
		margin-top: 32px;
	}

	.lp-highlight-items {
		display: flex;
		flex-wrap: nowrap;
		gap: 7%;
		justify-content: center;
		margin-bottom: 40px;
		padding: 0px 6%;
		${EmotionBreakpoint('mobile')} {
			gap: 80px;
			flex-direction: column;
			flex-wrap: none;
			padding: 0px 0px;
		}
		${EmotionBreakpoint('tablet')} {
			gap: 64px;
			flex-direction: column;
			flex-wrap: none;
			padding: 0px 0px;
		}
	}

	.lp-highlight-item {
		display: flex;
		padding: 32px;
		flex-direction: column;
		align-items: stretch;
		gap: 16px;
		text-align: left;
		background-color: ${(props) => props.highlightBackgroundColor || '#203c5d'};
		color: ${(props) => props.highlightTextColor || '#ffffff'};
		border-radius: 4px;
		position: relative;
		width: 100%;

		${EmotionBreakpoint('mobile')} {
			position: relative;
			padding: 26px 16px;
			width: auto;
		}
		${EmotionBreakpoint('tablet')} {
			position: relative;
			padding: 26px 16px;
			width: auto;
		}

		.image-wrap {
			right: 6px;
			bottom: 1rem;
			position: absolute;
			${EmotionBreakpoint('mobile')} {
				position: absolute;
				right: 27px;
				bottom: 4rem;
			}
			${EmotionBreakpoint('tablet')} {
				position: absolute;
				right: 27px;
				bottom: 4rem;
			}

			.large-image {
				max-width: 240px;
				max-height: 240px;
				border-radius: 4px;
				${EmotionBreakpoint('mobile')} {
					max-width: 120px;
					max-height: 120px;
					bottom: 25px !important;
				}
				${EmotionBreakpoint('tablet')} {
					max-width: 200px;
					max-height: 200px;
				}
			}

			.small-image {
				max-width: 240px;
				max-height: 240px;
				border-radius: 4px;
				${EmotionBreakpoint('mobile')} {
					max-width: 120px;
					max-height: 120px;
					bottom: 25px !important;
				}
				${EmotionBreakpoint('tablet')} {
					max-width: 200px;
					max-height: 200px;
				}
			}
		}
		.image-wrap .large-image {
			position: relative; /* Change from static so bottom works */
		}
		.image-wrap .small-image {
			position: relative; /* Change from static so bottom works */
		}

		.fox & {
			font-family: Roboto;
			font-size: 22px;
			font-style: normal;
			font-weight: 600;
			line-height: 120%;
			letter-spacing: -0.22px;
		}

		h3 {
			align-self: stretch;
			color: ${(props) => props.highlightTextColor || '#ffffff'};
			font-family: Escrow;
			font-size: 24px;
			font-style: normal;
			font-weight: 400;
			line-height: 28px;
			.fox & {
				font-family: Roboto;
				font-size: 22px;
				font-style: normal;
				font-weight: 600;
				line-height: 120%;
				letter-spacing: -0.22px;
				width: 55%;
			}
			.bon & {
				font-family: 'FuturaPT';
				font-size: 24px;
				font-style: normal;
				font-weight: 450;
				line-height: 28px;
			}
			.law & {
				font-family: 'Noto Serif';
				font-size: 22px;
				font-style: normal;
				font-weight: 600;
			}
			.osw & {
				font-family: 'Neue Haas Grotesk Text Pro';
				font-size: 22px;
				font-style: normal;
				font-weight: 400;
			}
			.npr & {
				font-family: 'Gotham';
				font-size: 22px;
				font-style: normal;
				font-weight: 325;
			}

			${EmotionBreakpoint('mobile')} {
				font-size: 20px;
				width: 175px;
			}
			${EmotionBreakpoint('tablet')} {
				font-size: 20px;
				width: 175px;
			}
			@media (width: 1024px) {
				width: 45% !important;
			}
		}

		p {
			align-self: stretch;
			color: ${(props) => props.highlightTextColor || '#ffffff'};
			font-family: Arial;
			font-size: 14px;
			font-style: normal;
			font-weight: 400;
			line-height: 20px;
			width: 50%;
			.fox & {
				font-family: Roboto;
				font-size: 14px;
				font-style: normal;
				font-weight: 400;
				line-height: 120%;
			}

			.bon & {
				font-family: 'FuturaPT';
				font-size: 18px;
				font-style: normal;
				font-weight: 400;
				line-height: 20px;
			}
			.law & {
				font-family: 'Roboto';
				font-size: 14px;
				font-style: normal;
				font-weight: 400;
			}
			.osw & {
				font-family: 'Roboto';
				font-size: 14px;
				font-style: normal;
				font-weight: 400;
			}
			.npr & {
				font-family: 'Roboto';
				font-size: 14px;
				font-style: normal;
				font-weight: 400;
			}
			${EmotionBreakpoint('mobile')} {
				font-size: 14px;
				width: 311px;
				.fox & {
					font-family: Roboto;
				}
			}
			${EmotionBreakpoint('tablet')} {
				font-size: 14px;
				width: 311px;
				.fox & {
					font-family: Roboto;
				}
			}
			@media (width: 1024px) {
				width: 40%;
			}
		}
	}
`;

// Component
const HighlightSection = ({ contentfulData }) => {
	const {
		highlightItemHeadlines = [],
		highlightItemBody = [],
		highlightItemImages = [],
		highlightBackgroundColor,
		highlightTextColor,
	} = contentfulData || {};

	return (
		<HighlightContainer
			className='lp-highlight'
			highlightBackgroundColor={
				highlightBackgroundColor?.value || highlightBackgroundColor
			}
			highlightTextColor={highlightTextColor?.value || highlightTextColor}
		>
			<div className='lp-highlight-items'>
				{highlightItemHeadlines.map((title, index) => (
					<div className='lp-highlight-item' key={`lp-highlight-item-${index}`}>
						{/* Image */}
						{highlightItemImages[index]?.fields?.file?.url && (
							<div className='image-wrap'>
								<img
									src={`https:${highlightItemImages[index].fields.file.url}`}
									alt={title || 'Highlight Image'}
									className={
										index === 0
											? 'large-image'
											: index === 1
											? 'small-image'
											: ''
									}
								/>
							</div>
						)}

						{/* Title */}
						{title && <h3>{title}</h3>}

						{/* Body */}
						{highlightItemBody[index] && <p>{highlightItemBody[index]}</p>}
					</div>
				))}
			</div>
		</HighlightContainer>
	);
};

export default HighlightSection;
